import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Что включает тренинг по переговорам?',
      answer: 'Программа включает диагностику переговорной практики компании, интервью с участниками, адаптацию программы под специфику бизнеса, практический тренинг (80% практики), переговорные поединки, разбор реальных кейсов участников, домашнюю практику и посттренинговое сопровождение от 1 до 6 месяцев. Каждый этап направлен на закрепление навыков и внедрение изменений в ежедневную работу.',
    },
    {
      question: 'Чем отличается обучение продажам от переговоров?',
      answer: 'Продажи направлены на завершение конкретной сделки и получение заказа. Переговоры — более широкий навык: это управление решениями другой стороны, поиск взаимовыгодных решений, работа с интересами и долгосрочными отношениями. Переговоры включают продажи, но не ограничиваются ими — это коммуникация с закупщиками, партнёрами, подразделениями, руководителями. Обучение переговорам даёт инструменты для любых коммуникационных ситуаций, а не только для коммерческих.',
    },
    {
      question: 'Можно ли провести тренинг только для руководителей?',
      answer: 'Да, мы проводим отдельные программы для руководителей высшего и среднего звена. В фокусе — стратегические переговоры с партнёрами и ключевыми клиентами, управление конфликтами на уровне первых лиц, межведомственные переговоры, защита интересов компании в сложных многосторонних переговорах. Программа адаптируется под уровень участников и их реальные задачи.',
    },
    {
      question: 'Можно ли использовать реальные кейсы компании на тренинге?',
      answer: 'Да, и это обязательная часть программы. Мы разбираем реальные переговорные ситуации участников: сложные клиенты, проблемные тендеры, переговоры с закупщиками, внутренние конфликты между подразделениями. Это повышает вовлечённость участников и позволяет сразу применить полученные навыки на практике в знакомых ситуациях.',
    },
    {
      question: 'Как проходит сопровождение после тренинга по переговорам?',
      answer: 'Сопровождение включает регулярные встречи с руководителем (раз в 1–2 недели), разбор сложных переговорных кейсов, поддержку в чате для оперативных вопросов, корректировку переговорной стратегии, выборочный аудит проведённых встреч и переговоров. Длительность сопровождения — от 1 до 6 месяцев в зависимости от задач и выбранной программы.',
    },
    {
      question: 'Можно ли обучить закупщиков переговорам?',
      answer: 'Да, у нас есть отдельные модули для отделов закупок. В программе: переговоры с поставщиками, тендерные процедуры и стратегии, снижение закупочных цен без потери качества и отношений, построение долгосрочных партнёрств с контрагентами, управление конфликтами в цепочке поставок, работа с монопольными поставщиками.',
    },
    {
      question: 'Работаете ли вы онлайн?',
      answer: 'Да, тренинг по переговорам проводится в онлайн-формате с использованием интерактивных инструментов, переговорных поединков через видеосвязь, разбора реальных кейсов и записи сессий для последующего анализа. Онлайн-формат не уступает очному по эффективности при правильной организации процесса.',
    },
    {
      question: 'Какие результаты обычно получают компании после тренинга по переговорам?',
      answer: 'Результаты зависят от целей, но типичные показатели: рост конверсии переговоров в сделки на 18–55%, увеличение среднего чека, снижение процента предоставляемых скидок, рост продлений договоров (например, с 64% до 84% у компании Israel Assist), рост маржинальности сделок, сокращение цикла переговоров на 30–40%. Каждый проект имеет конкретные измеримые KPI.',
    },
    {
      question: 'Как оценивается эффективность тренинга по переговорам?',
      answer: 'Эффективность оценивается по конкретным показателям, зафиксированным до и после обучения: рост конверсии встреч в сделки, изменение среднего чека, снижение процента скидок, рост количества долгосрочных контрактов, сокращение среднего цикла переговоров, рост маржинальности. Мы фиксируем исходные показатели на этапе диагностики и отслеживаем динамику через 1, 3 и 6 месяцев.',
    },
    {
      question: 'Сколько длится программа тренинга по переговорам?',
      answer: 'Продолжительность зависит от выбранного формата и задач: интенсив — 1–2 дня, модульное обучение — от 2 недель до 3 месяцев, комплексная программа с сопровождением — от 1 до 6 месяцев. Мастер-класс длится 3–4 часа. Точная продолжительность определяется после диагностики и согласования целей обучения.',
    },
    {
      question: 'Что такое переговорные поединки?',
      answer: 'Переговорные поединки — это моделирование реальных переговорных ситуаций, где участники ведут переговоры друг с другом или с тренером, а остальная группа наблюдает и анализирует. После каждого поединка — детальная обратная связь: что сработало, где потеряли позицию, как можно было усилить аргументацию. Это самый эффективный формат отработки навыков переговоров.',
    },
    {
      question: 'Нужно ли готовиться к тренингу?',
      answer: 'С нашей стороны подготовка включает диагностику, интервью и адаптацию программы. Со стороны компании мы просим предоставить реальные кейсы переговоров для разбора, доступ к записям звонков (при согласии участников) и информацию о продукте и рынке. Чем лучше мы подготовимся, тем эффективнее будет обучение.',
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы о <strong>тренинге по переговорам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые популярные вопросы о <strong>корпоративном обучении переговорам</strong>. Если вы не нашли ответа — напишите или позвоните.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}